import { makeStyles } from '@material-ui/core';

export default makeStyles((theme: any) => ({
  title: {
    fontWeight: 'bold',
    fontSize: 28,
  },
  label: {
    fontSize: 14,
    color: theme.palette.primary.dark,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  selectLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    paddingBottom: 10,
  },
  button: {
    margin: '40px  0px 14px 0px',
  },
  actionsContainer: {
    padding: '0px 25px',
  },
}));
